export default "__VITE_ASSET__DSyi0j0n__"